<template>
  <BaseSimuladorIndicadorModal
    ref="baseModal"
    :modal-id="modalId"
    title="Simulador"
    numerador-label="Numerador"
    denominador-label="Denominador"
    :valor-numerador="nManual"
    :valor-denominador="dManual"
    :base-numerador="baseNumerador"
    :base-denominador="baseDenominador"
    :procedimentos-numerador="PROCEDIMENTOS_NUMERADOR"
    :procedimentos-denominador="PROCEDIMENTOS_DENOMINADOR"
    :tipos="TIPOS_CLASSIFICACAO"
    :calculate-result-fn="calcularResultado"
    :calculate-class-fn="calcularClasse"
    :apply-preset-fn="aplicarPreset"
    :format-delta-fn="formatDelta"
    :result-text-fn="montarTextoResultado"
    hint="💡 Os botões preenchem valores de exemplo. Ajuste manualmente pelos controles acima."
    @update:numerador="setNumerador"
    @update:denominador="setDenominador"
  />
</template>

<script>
import BaseSimuladorIndicadorModal from '@/pages/IndicadoresAps/components/BaseSimuladorIndicadorModal.vue'

export default {
  name: 'SimuladorOdontoModal',
  components: {
    BaseSimuladorIndicadorModal,
  },
  props: {
    modalId: {
      type: String,
      default: 'simulador-odonto-modal',
    },
    dadosPercentualMunicipio: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualEquipe: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualMicroArea: {
      type: Object,
      default: () => ({}),
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nManual: 0,
      dManual: 1,
      baseNumerador: 0,
      baseDenominador: 1,

      TIPOS_CLASSIFICACAO: [
        { value: 'Ótimo', label: 'Ótimo', description: '>= 8 e < 10' },
        { value: 'Bom', label: 'Bom', description: '>= 10 e < 12' },
        {
          value: 'Suficiente',
          label: 'Suficiente',
          description: '>= 12 e < 14',
        },
        { value: 'Regular', label: 'Regular', description: '< 8 e >= 14' },
      ],
      PROCEDIMENTOS_NUMERADOR: [
        {
          icon: '🦷',
          codigo: '04.14.02.013-8',
          desc: 'Exodontia de dente permanente',
        },
        {
          icon: '🦷',
          codigo: '04.14.02.014-6',
          desc: 'Exodontia múltipla com alveoloplastia por sextante',
        },
      ],
      PROCEDIMENTOS_DENOMINADOR: [
        {
          icon: '🩺',
          codigo: '01.01.02.005-8',
          desc: 'Aplicação de cariostático (por dente)',
        },
        {
          icon: '🩺',
          codigo: '01.01.02.006-6',
          desc: 'Aplicação de selante (por dente)',
        },
        {
          icon: '🩺',
          codigo: '01.01.02.007-4',
          desc: 'Aplicação tópica de flúor (individual por sessão)',
        },
        {
          icon: '🩺',
          codigo: '01.01.02.008-2',
          desc: 'Evidenciação de placa bacteriana',
        },
        {
          icon: '🩺',
          codigo: '01.01.02.009-0',
          desc: 'Selamento provisório de cavidade dentária',
        },
        { icon: '🩺', codigo: '03.07.01.001-5', desc: 'Capeamento pulpar' },
        {
          icon: '🩺',
          codigo: '03.07.01.003-1',
          desc: 'Restauração de dente permanente anterior com resina composta',
        },
        {
          icon: '🩺',
          codigo: '03.07.01.006-6',
          desc: 'Tratamento inicial do dente traumatizado',
        },
        {
          icon: '🩺',
          codigo: '03.07.01.007-4',
          desc: 'Tratamento restaurador atraumático (TRA/ART)',
        },
        {
          icon: '🩺',
          codigo: '03.07.01.008-2',
          desc: 'Restauração de dente decíduo posterior com resina composta',
        },
        {
          icon: '🩺',
          codigo: '03.07.01.010-4',
          desc: 'Restauração de dente decíduo posterior com ionômero de vidro',
        },
        {
          icon: '🩺',
          codigo: '03.07.01.011-2',
          desc: 'Restauração de dente decíduo anterior com resina composta',
        },
        {
          icon: '🩺',
          codigo: '03.07.01.012-0',
          desc: 'Restauração de dente permanente posterior com resina composta',
        },
        {
          icon: '🩺',
          codigo: '03.07.01.013-9',
          desc: 'Restauração de dente permanente posterior com amálgama',
        },
        {
          icon: '🩺',
          codigo: '03.07.02.001-0',
          desc: 'Acesso à polpa dentária e medicação (por dente)',
        },
        {
          icon: '🩺',
          codigo: '03.07.02.002-9',
          desc: 'Curativo de demora com ou sem preparo biomecânico',
        },
        { icon: '🩺', codigo: '03.07.02.007-0', desc: 'Pulpotomia dentária' },
        {
          icon: '🩺',
          codigo: '03.07.03.002-4',
          desc: 'Raspagem e alisamento subgengivais (por sextante)',
        },
        {
          icon: '🩺',
          codigo: '03.07.03.004-0',
          desc: 'Profilaxia / remoção da placa bacteriana',
        },
        {
          icon: '🩺',
          codigo: '03.07.03.005-9',
          desc: 'Raspagem, alisamento e polimento supragengivais (por sextante)',
        },
        {
          icon: '🩺',
          codigo: '03.07.03.006-7',
          desc: 'Tratamento de gengivite ulcerativa necrosante aguda (GUNA)',
        },
        {
          icon: '🩺',
          codigo: '03.07.03.007-5',
          desc: 'Tratamento de lesões da mucosa oral',
        },
        {
          icon: '🩺',
          codigo: '03.07.03.008-3',
          desc: 'Tratamento de pericoronarite',
        },
        {
          icon: '🩺',
          codigo: '04.14.02.013-8',
          desc: 'Exodontia de dente permanente',
        },
        {
          icon: '🩺',
          codigo: '04.14.02.014-6',
          desc: 'Exodontia múltipla com alveoloplastia por sextante',
        },
      ],
    }
  },
  methods: {
    open() {
      this.aplicarFonte()
      this.$refs.baseModal.open()
    },

    close() {
      this.$refs.baseModal.close()
    },

    aplicarFonte() {
      let fonte = this.dadosPercentualMunicipio

      if (this.selectedMicroArea) {
        fonte = this.dadosPercentualMicroArea
      } else if (this.selectedEquipe) {
        fonte = this.dadosPercentualEquipe
      }

      const numerador = Number(fonte?.numerador) || 0
      const denominador = Number(fonte?.denominador) || 1

      this.nManual = numerador
      this.dManual = denominador
      this.resetBase()
    },

    setNumerador(valor) {
      this.nManual = valor
    },

    setDenominador(valor) {
      this.dManual = valor
    },

    resetBase() {
      this.baseNumerador = this.nManual
      this.baseDenominador = this.dManual
    },

    calcularResultado({ numerador, denominador }) {
      const d = Number(denominador) || 0
      if (d <= 0) return 0

      const n = Number(numerador) || 0
      return Number(((n / d) * 100).toFixed(2))
    },

    calcularClasse({ resultado }) {
      if (resultado >= 8 && resultado < 10) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado >= 10 && resultado < 12) {
        return { nivel: 'Bom', variant: 'success' }
      }
      if (resultado >= 12 && resultado < 14) {
        return { nivel: 'Suficiente', variant: 'warning' }
      }
      if (resultado < 8 && resultado >= 14)
        return { nivel: 'Regular', variant: 'danger' }

      return { nivel: 'Regular', variant: 'danger' }
    },

    aplicarPreset({ tipo, setNumerador, setDenominador }) {
      if (tipo === 'Ótimo') {
        setNumerador(8)
        setDenominador(100)
      } else if (tipo === 'Bom') {
        setNumerador(10)
        setDenominador(100)
      } else if (tipo === 'Suficiente') {
        setNumerador(12)
        setDenominador(100)
      } else {
        setNumerador(7)
        setDenominador(100)
      }

      this.$nextTick(() => {
        this.resetBase()
      })
    },

    formatDelta(val) {
      if (val > 0) return `+${val}`
      if (val < 0) return `${val}`
      return ''
    },

    montarTextoResultado({ resultado }) {
      return `NM / DN × 100`
    },
  },
}
</script>
